<template>
  <!-- App.vue -->

  <v-app :id="cId">
    <!--v-app-bar app dense>
      <app-topbar></app-topbar>
    </v-app-bar>
    <v-navigation-drawer app permanent expand-on-hover v-show="!show">

      <app-sidebar class="sidebar"></app-sidebar>
    </v-navigation-drawer-->

    <!-- Sizes your content based upon application components -->
    <v-container>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <!-- <v-toolbar flat>
          <v-spacer></v-spacer>

          
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline"
                >Are you sure you want to delete {{ editedItem.name }}'s tier
                ?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="closeDelete">ยกเลิก</v-btn>
                <v-btn color="success" @click="deleteItemConfirm">ยืนยัน</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar> -->

          <v-overlay
            :absolute="absolute"
            :value="responseStatus.alertStatus"
            v-if="responseStatus.alertStatus"
          >
            <v-btn
              :color="responseStatus.color"
              @click="responseStatus.alertStatus = false"
            >
              {{ responseStatus.text }}
            </v-btn>
          </v-overlay>

          <v-data-table
            :sort-by.sync="options.sortBy"
            :sort-desc.sync="options.sortDesc"
            :headers="headers"
            :items="tier"
            :options.sync="options"
            :footer-props="{ 'items-per-page-options': [-1] }"
          >
            <template v-slot:item.limit="{ item }">
              <v-text-field
                v-model="limit[item._id]"
                label="จำนวน"
                type="number"
                min="0"
              ></v-text-field>
            </template>
            <template v-slot:item.value="{ item }">
              <v-text-field
                v-model="value[item._id]"
                label="มูลค่า"
                type="number"
                min="0"
              ></v-text-field>
            </template>
            <template v-slot:item.monthLimit="{ item }">
              <v-text-field
                v-model="monthLimit[item._id]"
                label="ครั้ง"
                type="number"
                min="0"
              ></v-text-field>
            </template>
            <!-- <template v-slot:item.status="{ item }">
            <v-switch
              v-model="item.status"
              label=""
              color="success"
              value="Active"
              hide-details
              @click="clickSwitch(item)"
            ></v-switch>
          </template>
          -->

            <!-- <template v-slot:item.actions="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              v-if="item.is_admin != 'Y'"
            >
              mdi-pencil
            </v-icon>

            <v-icon small @click="deleteItem(item)" v-if="item.is_admin != 'Y'">
              mdi-delete
            </v-icon>
          </template> -->
            <template v-slot:no-data> </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="success" @click="save">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";

//import AppSideBar from "../menu/sideBarMenu";
//import AppTopBar from "../menu/topBarMenu";

export default {
  props: {
    privilegeId: {
      type: String,
    },
    cId: { type: String },
  },
  components: {
    /*
"app-sidebar": AppSideBar,
    "app-topbar": AppTopBar,
*/
  },
  data() {
    return {
      closeInSec: 3000,
      absolute: true,
      dialog: false,
      dialogDelete: false,
      tierPrivilege: [],
      // editedItem: {
      //   name: "",
      //   status: "",
      // },
      item: {},
      limit: {},
      value: {},
      monthLimit: {},
      show: false,
      responseStatus: {
        alertStatus: false,
      },
      defaultItem: {},
      editedIndex: -1,
      edit: false,
      payload: {},
      api_uri: process.env.VUE_APP_LOYALTY_API_URI,
      totalItems: 0,
      options: { sortBy: "createdAt", sortDesc: true },
      tier: [],
      load: false,
      headers: [
        {
          value: "name",
          text: "เทียร์",
        },
        {
          value: "limit",
          text: "ใช้ได้ (ครั้ง)",
        },
        // {
        //   value: "value",
        //   text: "มูลค่า",
        // },
        {
          value: "monthLimit",
          text: "เดือนละไม่เกิน (ครั้ง)",
        },
      ],
    };
  },
  computed: {
    tierFilter() {
      console.log("computed");
      if (this.search.length > 0) {
        return this.Tier.filter(() => {
          //return item.name.toLowerCase().startsWith(this.search.toLowerCase());
          this.readTier().then((response) => {
            this.Tier = response.data;
            this.totalItems = response.totalItems;
          });
        });
      } else {
        return this.Tier;
      }
    },
    formTitle() {
      return this.editedIndex === -1 ? "เพิ่ม" : "แก้ไข";
    },
  },
  async mounted() {
    console.log("Tier Privileges: ");
    console.log(this.privilegeId);
    //
    this.listTier();
    await this.readTierPrivilege();
    //this.totalItems = -1;

    console.log(this.limit);
    console.log(this.value);
    this.load = true;
  },

  methods: {
    async readTierPrivilege() {
      ////const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        let payload = {
          custId: sessionStorage.getItem("custId"),
          privilegeId: this.privilegeId,
          page: this.options.page - 1,
          limit: this.options.itemsPerPage,
          filter: this.search,
        };
        let response = await this.$store.dispatch("getTierPrivilegesList", payload);
        //console.log(this.$store.getters.getAllPrivileges);
        //console.log("readTierPrivilege");
        console.log(response);

        if (response.length <= 0) {
          //console.log(response);
          this.responseStatus = {
            status: "Error",
            code: response.code,
            message: response.message,
          };
          //return [];
        } else {
          //console.log("  response ");
          //console.log(this.$store.getters.getAllTPrivileges);
          response.map((item) => {
            //console.log(item);
            this.limit[`${item.tierId}`] = item.limit;
            this.monthLimit[`${item.tierId}`] = item.monthLimit;
          });

          //return response; //this.$store.getters.getAllPrivileges;
        }
      } catch (err) {
        this.responseStatus = {
          status: "Error",
          code: 500,
          message: err,
        };
        //return [];
      }
    },
    async listTierPrivilege() {},

    listTier() {
      this.readTier().then((response) => {
        //console.log(response.data);
        this.tier = response.data;
        this.totalItems = response.totalItems;
      });
    },

    /*   listSubTier(name, id) {
      this.$router.push(
        "/admin/members/tiers/" +
          id +
          "-" +
          name +
          "/subtier"
      );
    }, */

    click(item, row) {
      console.log(item);
      console.log(row);
    },
    readTier() {
      const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        this.payload = {
          custId: sessionStorage.getItem("custId"),
          page: this.options.page - 1,
          limit: this.options.itemsPerPage,
          filter: this.search,
        };
        return axios
          .get(
            url + "/v1/tier/list",
            { params: this.payload } // need to change
          )
          .then((response) => {
            return response.data;
          });
      } catch (err) {
        this.responseStatus = {
          status: "Error",
          code: 500,
          message: err,
        };
      }
    },
    // editItem(item) {
    //   this.editedIndex = this.tier.indexOf(item);
    //   this.editedItem = Object.assign({}, item);
    //   this.edit = this.editedIndex !== -1 ? true : false;
    //   this.dialog = true;
    // },

    // deleteItem(item) {
    //   this.editedIndex = this.tier.indexOf(item);
    //   this.editedItem = Object.assign({}, item);
    //   this.dialogDelete = true;
    // },
    // editPermission(item) {
    //   //console.log(item)
    //   this.dialogPermission = true;
    //   this.editedItem = Object.assign({}, item);
    // },

    // async deleteItemConfirm() {
    //   const url = process.env.VUE_APP_LOYALTY_API_URI;
    //   try {
    //     this.payload = {
    //       createdBy: sessionStorage.getItem("email"),
    //       updatedBy: sessionStorage.getItem("email"),
    //       custId: sessionStorage.getItem("custId"),

    //       id: this.editedItem._id,
    //     };

    //     await axios
    //       .delete(
    //         //url + "/v1/tier-privilege/delete",
    //         url + "/v1/tier-privileges/" + this.editedItem._id,
    //         this.payload, // need to change
    //         {
    //           headers: {
    //             // Overwrite Axios's automatically set Content-Type
    //             "Content-Type": "application/json",
    //           },
    //         }
    //       )
    //       .then((response) => {
    //         if (response.data.ok == 1) {
    //           this.responseStatus = {
    //             status: "Success",
    //             code: 0,
    //             color: "green",
    //             type: "success",
    //             text: "บันทึกสำเร็จ",
    //             alertStatus: true,
    //           };
    //         }
    //       });
    //     //console.log(this.tier);
    //     if (this.responseStatus.code == 0) {
    //       this.tier.splice(this.editedIndex, 1);
    //       //this.readTier()
    //       this.listTier();
    //       //this.totalItems--;
    //     }
    //   } catch (err) {
    //     return (this.responseStatus = {
    //       status: "Error",
    //       code: 500,
    //       color: "red",
    //       type: "error",
    //       text: err,
    //       alertStatus: true,
    //     });
    //   }

    //   this.closeDelete();
    // },

    close() {
      this.dialog = false;
      this.edit = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, {});
        this.editedIndex = -1;
      });
    },

    // closeDelete() {
    //   this.dialogDelete = false;
    //   this.$nextTick(() => {
    //     this.editedItem = Object.assign({}, {});
    //     this.editedIndex = -1;
    //   });
    // },
    // timeout close overlay
    closeInTime(sec) {
      setTimeout(() => {
        this.responseStatus.alertStatus = false;
      }, sec);
    },

    async save() {
      this.payload = {
        createdBy: sessionStorage.getItem("email"),
        updatedBy: sessionStorage.getItem("email"),
        custId: sessionStorage.getItem("custId"),
        privilegeId: this.privilegeId,
        value: this.value,
        limit: this.limit,
        monthLimit: this.monthLimit,
      };
      console.log(this.payload);
      if (this.editedIndex > -1) {
        console.log("update");
        const url = process.env.VUE_APP_LOYALTY_API_URI;

        try {
          await axios
            .put(
              url + "/v1/tier-privileges/update",
              this.payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              console.log(response.data);
              //this.tier = response.data;
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
                data: response.data,
              };
              //console.log(this.responseStatus)
              this.tier = response.data;
            });

          //console.log(this.tier);
          //console.log("updated");
          if (this.tier.nModified == 1) {
            Object.assign(this.tier[this.editedIndex], this.editedItem);
          } else {
            // do something
          }
        } catch (err) {
          console.log("err");
          console.log(err);
          //return err;
          return (this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          });
        }
      } else {
        const url = process.env.VUE_APP_LOYALTY_API_URI;
        try {
          // this.payload = {
          //   createdBy: sessionStorage.getItem("email"),
          //   updatedBy: sessionStorage.getItem("email"),
          //   custId: sessionStorage.getItem("custId"),

          //   //name: this.editedItem.name,
          //   //image: this.image,
          //   //tier: this.$route.params.id,
          //   //tierName: this.$route.param.tier,
          //   //status: "Active",
          //   //custId: sessionStorage.getItem("custId"),
          // };
          await axios
            .post(
              url + "/v1/tier-privileges/create",
              this.payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
                data: response.data,
              };
              this.totalItems++;
            })
            .catch((error) => {
              console.log(error);
            });
        } catch (err) {
          return (this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          });
        }
      }
      console.log("saved");
      this.listTier();
      this.close();
    },
  },

  watch: {
    limit: {
      handler() {
        console.log(this.limit);
        console.log("limit");
        console.log(JSON.stringify(this.limit));
        // this.limit.forEach(([key, value], index) => {
        //   console.log(index);
        //   console.log(key);
        //   console.log(`${key}: ${value}`);
        // });
        //console.log(val);
      },
    },
    // options: {
    //   handler() {
    //     //console.log(this.options);
    //     this.payload = {
    //createdBy: sessionStorage.getItem("email"),
    // updatedBy: sessionStorage.getItem("email"),
    // custId: sessionStorage.getItem("custId"),

    //       custId: sessionStorage.getItem("custId"),
    //       page: this.options.page - 1,
    //       limit: this.options.itemsPerPage,
    //     };

    //     this.readTier().then((response) => {
    //       this.tier = response.data;
    //       this.totalItems = response.totalItems;
    //     });
    //   },
    //   deep: true,
    // },
    editPermission: {
      handler() {
        console.log(this.editPermission);
      },
    },

    search: {
      handler() {
        console.log("search");
        // this.readTier().then((response) => {
        //   this.tier = response.data;
        //   this.totalItems = response.totalItems;
        // });
      },
    },
    dialog(val) {
      //console.log(val);
      val || this.close();
    },
    dialogDelete(val) {
      //console.log(val);
      val || this.closeDelete();
    },
    totalItems: {
      handler() {
        console.log("totalItems");
        //console.log(this.totalItems)
        // this.readTier().then((response) => {
        //   this.tier = response.data;
        //   this.totalItems = response.totalItems;
        // });
      },
    },
    responseStatus: {
      handler() {
        if (this.responseStatus.alertStatus === true) {
          this.closeInTime(this.closeInSec);
        }
      },
    },
  },
};
</script>
